// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list-builder .has-float-label{margin-top:.5rem}.list-builder .search-field.input-group{display:flex;gap:10px;justify-content:space-between;width:100%}.list-builder .search-field.input-group button.btn{border-radius:1px;flex-shrink:0;margin-left:3px;width:50px}", ""]);
// Exports
module.exports = exports;
